
        var fileData = { root: require("./api-urls.js?raw=true") };
        module.exports = function load(country) {
          return fileData[country] || fileData[country.substr(0, 2)] || fileData["root"];
        };